<template lang="pug">

    .card(v-if='isVisible')
        router-link.image(v-bind:to='{ name: "products/create/step1", params: { key: formsKey }}')
            slot
        .content
            .description {{ name }}

</template>

<script>

    //noinspection ReservedWordAsName,JSUnusedGlobalSymbols
    export default {

        computed: {

            isVisible() {
                return this.parent === this.$route.params.key
            },

        },

        props: {
            name: {
                type: String,
                required: true
            },
            formsKey: {
                type: String,
                require: true
            },
            parent: {
                type: String
            }
        }

    }

</script>
